import { ForwardedRef, forwardRef } from 'react';

import { SelectInputProps } from './select.types';

const styles = {
  base: 'rounded-lg focus:border-1 focus:border-midnight-900 focus:ring-midnight-900 my-px placeholder-gray-600 truncate border-gray-600',
  sizes: {
    medium: 'h-8 pr-[calc(4.25rem-4px)] text-sm',
    large: 'h-11 pr-[calc(5.75rem-4px)] text-base',
  },
};

const SelectInput = forwardRef((props: SelectInputProps, ref: ForwardedRef<HTMLInputElement>) => {
  const { allowClear, inputId, value, contentWidth, onClearSelection, onSearch, containerSize, ...rest } = props;
  const key = `Input-${inputId}`;

  return (
    <input
      ref={ref}
      role="searchbox"
      className={`${styles.base} ${styles.sizes[containerSize]}`}
      type="text"
      title={value?.toString() ?? ''}
      key={key}
      data-testid={key}
      value={value ?? ''}
      onChange={(e) => {
        if (e.target.value.length > 0 || !allowClear) onSearch(e.target.value);
        else onClearSelection?.(e);
      }}
      style={{ width: contentWidth }}
      {...rest}
    />
  );
});

SelectInput.displayName = 'SelectInput';

export default SelectInput;
